import * as React from 'react';
import { EVENT_RESULTS_MODE } from 'Src/consts/event';

interface Props {
  resultsMode: string;
  isMultipartyEvent: boolean;
  onResultsModeClick: (resultsMode: string) => void;
}

export function ResultsMode(props: Props) {
  const { resultsMode, isMultipartyEvent, onResultsModeClick } = props;

  // A standard two-sided event only supports score entry. Showing a selector
  // with two disabled alternatives makes a fixed setting look configurable.
  if (!isMultipartyEvent) {
    return null;
  }

  return (
    <div className="eResultsMode">
      <div className="eResultsMode__title">Results input mode</div>
      <div className="eResultsMode__options">
        <label className={`eResultsMode__option ${resultsMode === EVENT_RESULTS_MODE.PLACES ? 'is-active' : ''}`}>
          <input
            type="radio"
            name="places"
            id="places"
            value={EVENT_RESULTS_MODE.PLACES}
            checked={resultsMode === EVENT_RESULTS_MODE.PLACES}
            onChange={() => {
              onResultsModeClick(EVENT_RESULTS_MODE.PLACES);
            }}
          />
          <span>
            <strong>Places</strong>
            <small>First place wins</small>
          </span>
        </label>
        <label className={`eResultsMode__option ${resultsMode === EVENT_RESULTS_MODE.POINTS ? 'is-active' : ''}`}>
          <input
            type="radio"
            name="points"
            id="points"
            value={EVENT_RESULTS_MODE.POINTS}
            checked={resultsMode === EVENT_RESULTS_MODE.POINTS}
            onChange={() => {
              onResultsModeClick(EVENT_RESULTS_MODE.POINTS);
            }}
          />
          <span>
            <strong>Points</strong>
            <small>Highest total wins</small>
          </span>
        </label>
      </div>
    </div>
  );
}
